import { Utils } from "../../utils";

export const logInterReqError = async (error: any) => {
  Utils.pushLog({
    tags: ["HTTP", "ERROR"],
    message: error.message,
    extraArgs: [error],
    timeStamp: Date.now(),
  });

  return Promise.reject(error);
};
